import { axios } from '@/services/axios';

const getPlatformNumberById = async (numberId, platformId, accountScope) => {
    const res = await axios.get(
        `/PlatformNumber/${numberId}/Platform/${platformId}`,
        {
            headers: {
                'X-RequestScope': accountScope,
            },
        },
    );
    return res.data;
};

export default getPlatformNumberById;
